/**
 * @description: 根据文件名判断文件类型
 * @param {String} fileName 文件名
 */
export function getFileType(fileName) {
    if (fileName == null || fileName.indexOf(".") == -1) {
        return 'other';
    }
    // 文件后缀分类
    let fileSuffix = {
        video: ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'],
        audio: ['mp3', 'wav', 'wmv'],
        image: ['bmp', 'jpg', 'jpeg', 'png', 'gif'],
        word: ['doc', 'docx'],
        excel: ['xls', 'xlsx'],
        ppt: ['ppt', 'pptx', 'pptm'],
        pdf: ['pdf'],
        txt: ['txt']
    };
    // 判断文件类型
    let suffix = fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase();
    for (let key in fileSuffix) {
        if (fileSuffix[key].includes(suffix)) {
            return key;
        }
    }
    return 'other';
}

/**
 * @description: 空格校验
 * @param {rule, value, callback}
 */
export function verificationBlank(rule, value, callback){
	if (value !== null && value !== ''){
		if (value.indexOf(' ')!== -1){
			callback(new Error('不能包含空格！'));
		}else{
			callback();
		}
	}else{
		callback();
	}
}

/**
 * @description: 判断是否相等
 * @param {Any} valueA 判断值A
 * @param {Any} valueB 判断值B
 * @return {Boolean} 相等返回true
 */
export function isEqual(valueA, valueB) {
	let typeA = Object.prototype.toString.call(valueA);
	let typeB = Object.prototype.toString.call(valueB);
	if (typeA !== typeB) {
		return false
	}
	switch (typeA) {
		case '[object Object]': {
			let keysA = Object.keys(valueA)
			let keysB = Object.keys(valueB)
			if (keysA.length !== keysB.length) {
				return false
			}
			for (let i = 0, len = keysA.length; i < len; i++) {
				let key = keysA[i]
				if (!isEqual(valueA[key], valueB[key])) {
					return false
				}
			}
			return true;

		}
		case '[object Array]':
			if (valueA.length !== valueB.length) {
				return false
			}
			valueA.sort();
			valueB.sort();
			for (let i = 0, len = valueA.length; i < len; i++) {
				if (!isEqual(valueA[i], valueB[i])) {
					return false
				}
			}
			return true;
		default:
			return valueA === valueB;
	}
}

/**
 * @description: 判断是否为空
 * @param {Any} value 判断值
 * @return {Boolean} 为空返回true
 */
export function isEmpty(value) {
	if (value == null) {
		return true;
	}
	let type = Object.prototype.toString.call(value);
	switch (type) {
		case '[object String]':
			return value == "";
		case '[object Number]':
			return isNaN(value);
		case '[object Array]':
			return value.length == 0
		case '[object Object]':
			return Object.keys(value).length == 0
		case '[object Date]':
			return isNaN(value.getTime())
		case '[object Undefined]':
		case '[object Null]':
			return true
		default:
			return false;
	}
}

/**
 * @description: 判断是否为空
 * @param {Any} value 判断值
 * @return {Boolean} 有值返回true
 */
function isNotEmpty(value) {
	return isEmpty(value);
}

/**
 * @description: 日期格式化函数
 * @param {Date, Number, String} value 日期值
 * @param {String} fmt 格式化模板，默认为yyyy-MM-dd hh:mm，可为yyyy-MM-dd hh:mm:ss.SSS
 * @return {String} 格式化后的时间
 */
export function formatDate(value, fmt) {
	if (value == null || value === '') {
		return '';
	}
	if (fmt == null) {
		fmt = "yyyy-MM-dd hh:mm";
	}

	if (typeof value === 'string') {
		value = value.replace(/-/g, "/").replace("T", " ")
	}
	let date = new Date(value);
	let o = {
		"M+": date.getMonth() + 1, //月份
		"d+": date.getDate(), //日
		"h+": date.getHours(), //小时
		"m+": date.getMinutes(), //分
		"s+": date.getSeconds(), //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		"S": date.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (let k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
	return fmt;
}

/**
 * @description: 数字格式化
 * @param {Number, String} value 数字值
 * @param {Number} pos 保留小数位，默认为4
 * @param {Boolean} noZero 是否舍去小数位的0，默认为false
 * @return {String} 格式化后的返回值
 */
function formatFloat(value, pos, noZero = false) {
	if (value == null || value == '') {
		return 0;
	}
	if (pos == null || pos === '') {
		pos = 4;
	}

	value = Math.round(value * Math.pow(10, pos)) / Math.pow(10, pos);
	return noZero ? value : value.toFixed(pos);
}

/**
 * @description: 文件大小格式化
 * @param {Number} size 文件大小，单位B
 * @return {String} 格式化后的文件大小
 */
export function formatFileSize(size) {
	if (size == null) {
		return null;
	}
	let byteLimit = 1024,
		kbLimit = 1048576,
		mbLimit = 1073741824;
	let out;
	if (size < byteLimit) {
		out = size + 'B'
	} else if (size < kbLimit) {
		out = formatFloat(size / byteLimit, 2, true) + ' KB';
	} else if (size < mbLimit) {
		out = formatFloat(size / kbLimit, 2, true) + ' MB';
	} else {
		out = formatFloat(size / mbLimit, 2, true) + ' GB';
	}
	return out;
}

/**
 * @description: 对类型进行效验
 * @param {Any} value 判断值
 * @param {String} type 比对类型
 * @return {Boolean} 符合类型条件返回true
 */
export function isTypeof(value, type) {
	if (isEmpty(value)) {
		return false
	}
	switch (type) {
		case 'verificationCode':
			return value.toString().length === 6;
		case 'phone': {
			//手机号效验正则暂不完善
			let reg = new RegExp(/^1\d{10}$/)
			return reg.test(value.toString());
		}
		case 'password':
			// 密码效验暂不完善
			return value.toString().length >= 8 && value.toString().length <= 16;
		case 'num':
		case 'amount':
			return value > 0;
		case 'date':
			return value instanceof Date;
		case "array":
			return Array.isArray(value) && value.length > 0
		default:
			return false;
	}
}

/**
 * @description: 判断是否为有效值
 * @param {Object} value 判断值
 * @param {Array} keys 判断键值
 * @return {Boolean} 有效返回true
 */
export function isValid(value, keys) {
	if (isEmpty(value)) {
		return false
	}
	let type = Object.prototype.toString.call(value);
	switch (type) {
		case '[object Object]':
			for (let i = 0, len = keys.length; i < len; i++) {
				if (isNotEmpty(value[keys[i]])) {
					return true
				}
			}
			return false
		default:
			return false;
	}
}

/**
 * @description: 判断是否为有效值
 * @param {Object} value 判断值
 * @param {Array} keys 判断键值
 * @return {Boolean} 无效返回true
 */
export function isNotValid(value, keys) {
	return isValid(value, keys);
}

/**
 * @description: 处理清单数据
 * @param {Array} rows 清单
 * @param {Array} removed 删除清单
 * @param {Function} getDto Dto类格式化函数
 * @return {Array} 格式化后的清单数据
 */
export function handleRows(rows, removed, getDto) {
	if (removed == null || removed === '') {
		removed = []
	}
	if (getDto == null || getDto === '') {
		getDto = function(item) {
			return item
		}
	}
	// 清单作新增编辑删除分类
	let StoreRows = {
		added: [],
		updated: [],
		removed: removed.map(obj => ({
			id: obj.id
		}))
	};
	if (rows != null && rows.length > 0) {
		for (let i = 0, len = rows.length; i < len; i++) {
			if (rows[i].insertType === 'ADD') {
				StoreRows.added.push(getDto(rows[i]))
			} else if (rows[i].insertType === 'EDIT') {
				StoreRows.updated.push(getDto(rows[i]))
			}
		}
	}
	return StoreRows
}

/**
 * 通过 crypto 模块生成 UUID：
 */
export function getUUid() {
  return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0,
		v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

export default {
    getFileType
}

/**
 * 函数防抖
 * @param {Function} callback 需要防抖的函数
 * @param {Number} interval 间隔时间（ms）
 */
export function debounce(callback, interval = 1000) {
	let timeOut = null;
	return function(...args) {
		if (timeOut !== null) {
			clearTimeout(timeOut);
		}
		timeOut = setTimeout(() => {
			timeOut = null;
			callback.apply(this,args);
		}, interval);
	}
}

/**
 * @description: 金额格式化函数
 * @param {Number, String} value 金额值
 * @param {String} currency 货币符号，默认为￥
 * @param {Number} decimals 小数位数，默认为2
 * @return {String} 格式化后的金额
 */
export function currency(value, currency, decimals) {
	if (value == null || value === '') {
		return '';
	}
	if (value == Infinity) {
		return value;
	}
	if (currency == null) {
		currency = '￥';
	}
	if (decimals == null || decimals === '') {
		decimals = 2;
	}

	value = parseFloat(value);
	if (value == 0) {
		return currency.substr(-1, 1) === '元' ? (value + ' ' + currency) : (currency + value)
	}

	let stringified = Math.abs(value).toFixed(decimals);
	let _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
	let i = _int.length % 3;
	let head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) : '';
	let _float = decimals ? stringified.slice(-1 - decimals) : '';
	let sign = value < 0 && stringified !== '0.00' ? '-' : '';

	if (currency.substr(-1, 1) === '元') {
		return sign + head + _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') + _float + ' ' + currency;
	} else {
		return currency + sign + head + _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') + _float;
	}
}

/**
 * @description: 字符串安全保护，显示前几位和后几位，中间显示替位符
 * @param {Number, String} value 字符串值
 * @param {Number} startLen 显示前几位，默认为3
 * @param {Number} endLen 显示后几位，默认为4
 * @param {String} prefix 替位符，默认为*
 * @return {String} 格式化后的字符串
 */
export function securityStr(value, startLen, endLen, prefix) {
	if (value == null || value === '') {
		return '';
	}
	if (startLen == null || startLen === '' || startLen < 0) {
		startLen = 3;
	}
	if (endLen == null || endLen === '' || endLen < 0) {
		endLen = 4;
	}
	if (prefix == null || prefix === '') {
		prefix = "*";
	}

	let prefixLen = value.length - (startLen + endLen);
	if (prefixLen <= 0) {
		return value;
	}

	let startStr = value.substr(0, startLen);
	let endStr = value.substr(-endLen, endLen);
	let middleStr = "";
	for (let i = 0; i < prefixLen; i++) {
		middleStr += prefix;
	}

	return startStr + middleStr + endStr;
}
